import React, { memo, useMemo } from 'react';
import { Tabs } from 'antd';
import PropTypes from 'prop-types';

const CustomTab = ({ tabs, activeTab, onTabChange, className, type, tabBarExtraContent }) => {
  const tabItems = useMemo(() => (
    tabs.map(({ key, label, children,disabled }) => ({ key, label, children,disabled }))
  ), [tabs]);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      className={className}
      items={tabItems}
      type={type}
      tabBarExtraContent={tabBarExtraContent}
    />
  );
};

CustomTab.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  tabBarExtraContent: PropTypes.node
};

export default memo(CustomTab);
